{
    "moovyVirtualKeyboard.button.redeemPermit": "Redeem permit",
    "page.qrcode.welcome": "Welcome!",
    "page.device.login.button": "Login",
    "page.device.textfield.login.username": "Username",
    "page.device.textfield.login.password": "Password",
    "page.homePage.instructions.parkingInfo.organization": "{permitDuration}-hour parking permit",
    "page.homePage.instructions.parkingInfo.default": "Parking permit",
    "page.homePage.instructions.visitorMessage.default": "Parking permit is valid according to the information you enter.",
    "page.homePage.select.product": "Select a parking permit",
    "page.homePage.instructions.enterRegisterNumber": "ENTER LICENCE PLATE NUMBER: ",
    "page.homePage.instructions.registerNumber.arialabel": "Licence plate",
    "page.homePage.instructions.visitorMessage.organization.arialabel": "Organization",
    "page.homePage.toast.permitGranted": "Parking permit granted.",
    "page.homePage.toast.errorCreatingPermit": "Parking permit not granted.",
    "page.homePage.toast.errorCreatingPermit.localizedErrorMessage": "Parking permit not granted: {message}",
    "page.homePage.success.grantedSuccessfully": "Permit is granted successfully to license plate",
    "page.homePage.success.permitType": "Parking permit",
    "page.homePage.success.permitTime": "Validity",
    "page.homePage.success.licensePlate": "Licenseplate",
    "page.homePage.success.okButton": "Done",
    "page.homePage.success.clearingPage": "This page will be cleared after 10 seconds.",
    "page.homePage.configurationError.title": "Parking permit",
    "page.homePage.configurationError.body": "Unfortunately, it is not possible to issue permits. Please contact the staff.",
    "page.homePage.configurationError.alert": "Configuration information could not be fetched",
    "page.homePage.configurationError.button": "Try to load again",
    "page.passcodePrompt.header": "Input passcode",
    "page.passcodePrompt.label": "Passcode",
    "page.passcodePrompt.submit": "Submit",
    "page.passcodePrompt.configurationFetch.error": "Configuration fetch failed",
  "page.passcodePrompt.configurationFetch.error.401": "Wrong passcode",
    "page.passcodePrompt.configurationFetch.success": "Configuration was fetched successfully",
    "page.passcodePrompt.configurationFetch.reload": "Continue",
    "language.finnish": "Suomeksi",
    "language.english": "In English",
    "api.error.code.generic": "An error occurred",
    "moovyErrorPage.oops": "Oops!",
    "moovyErrorPage.message": "Sorry, an unexpected error has occurred. Please, check the url and try to refresh the view again.",
    "common.actions.error": "An error occurred",
    "common.actions.get.error": "Failed to get data",
    "common.actions.network.error.message": "Network request failed. Permit not granted.",
    "common.network.offline": "You’re currently offline. Please reconnect to continue using this service."
}